import axios from 'axios';

const client = axios.create({ baseURL: process.env.VUE_APP_API || '', timeout: 40000, withCredentials: true });
async function request(operation, payload) {
  try {
    const path = operation === 'login' ? '/auth/login' : '/auth/tfa/' + operation;
    const response = payload === undefined
      ? await client.get(path)
      : await client.post(path, new URLSearchParams(payload));
    if (!response.data || typeof response.data !== 'object' || response.data.error) throw new Error('Respuesta no válida. Recargue la página.');
    return response.data;
  } catch (error) {
    const message = error.response && error.response.data && error.response.data.error;
    throw new Error(typeof message === 'string' ? message : 'No se pudo confirmar la operación. Compruebe el estado antes de repetirla.');
  }
}
export const twoFactorRepository = {
  session: () => request('session'),
  async post(operation, payload = {}) {
    const session = await request('session');
    return request(operation, { ...payload, csrf_token: session.csrf_token });
  }
};
